import { KPI_VALUE_TIME_DECIMAL } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const videoViewsAvgTimeWatchedConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.avg_time_watched_by_views',
    id: 'average_time_watched',
    tooltip: 'kpi.tiktok.tooltip_avg_time_watched_by_views',
    icon: {
        name: 'play',
        style: colors.pink
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_TIME_DECIMAL,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader
};
